"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AccordionHeaderMixin = require("../../mixins/components/AccordionHeaderMixin");
var StyledAccordionHeader = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledAccordionHeader",
  componentId: "c11n-8-107-0__sc-pqgos7-0"
})(["", ""], _AccordionHeaderMixin.AccordionHeaderMixin);
exports.StyledAccordionHeader = StyledAccordionHeader;